import { ProjectStateReducerCreator } from '../types';

const clearPublishedEventUrlReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state) => {
    state.projectPublishedStatus = null;
    state.checkingPublishedStatus = false;
    state.publishStatusKnown = false;
  });
};

export default clearPublishedEventUrlReducer;
